import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateUser = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/User/CreateUser", formData);
  });
  return mutation;
};
export default useCreateUser;
